import React, { useEffect } from "react";

import Usuarios from "../components/Users/Users";
import i18n from "../i18n/config";

const UsersPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("list.breadcrumb", { ns: "usuarios" })}`;
  }, []);

  return <Usuarios />;
};

export default UsersPage;
